import * as React from "react";
import classnames from "classnames";
import { placeholderImage } from "@grandvisionhq/utils";
/* empty css               */
const CardImage = ({ alt, src, backgroundColor, imageHref, className, style, ...rest }) => {
  const image = /* @__PURE__ */ React.createElement(
    "img",
    {
      ...rest,
      className: classnames("card-image", !imageHref ? className : void 0, {
        "card-image--placeholder": !src
      }),
      src: src || placeholderImage.url,
      alt: alt || "",
      style: { backgroundColor, ...style }
    }
  );
  return imageHref ? /* @__PURE__ */ React.createElement("a", { href: imageHref, className: classnames("card-image-anchor", className) }, image) : image;
};
export {
  CardImage as default
};
//# sourceMappingURL=CardImage.js.map
